import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_12 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_13 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_20 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_21 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_22 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_29 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_30 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_31 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_38 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_39 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_40 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_47 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_48 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_49 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_56 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_57 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_58 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_65 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_66 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_67 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "row mb-6" }
const _hoisted_73 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_74 = { class: "col-lg-8 fv-row" }
const _hoisted_75 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_76 = { class: "row mb-6" }
const _hoisted_77 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_78 = { class: "col-lg-8 fv-row" }
const _hoisted_79 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_80 = { class: "row mb-6" }
const _hoisted_81 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_82 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_83 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_84 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_87 = { class: "fv-plugins-message-container" }
const _hoisted_88 = { class: "fv-help-block" }
const _hoisted_89 = { class: "row mb-6" }
const _hoisted_90 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_91 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_92 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "d-flex fv-row" }
const _hoisted_94 = { class: "col-lg-6" }
const _hoisted_95 = { class: "card-header border-0 align-items-center" }
const _hoisted_96 = { class: "card-title m-0" }
const _hoisted_97 = { class: "fw-bolder m-0" }
const _hoisted_98 = { class: "collapse show" }
const _hoisted_99 = { class: "card-body border-top p-9" }
const _hoisted_100 = { class: "row mb-6" }
const _hoisted_101 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-lg-8 fv-row" }
const _hoisted_103 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_104 = { class: "row mb-6" }
const _hoisted_105 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_106 = { class: "col-lg-8 fv-row" }
const _hoisted_107 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_108 = { class: "row mb-6" }
const _hoisted_109 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_110 = { class: "col-lg-8 fv-row" }
const _hoisted_111 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "row mb-6" }
const _hoisted_113 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_114 = { class: "col-lg-8 fv-row" }
const _hoisted_115 = { class: "col-lg-4 col-form-label fw-bold fs-6" }

import { showBackendError } from "@/assets/ts/_utils/ShowBackendError";
import { diffObjects } from "@/core/helpers/diffObjects";
import { AuthModule, ProyectosN2ListadoModule } from "@/store/modules";
import { ElNotification } from "element-plus";
import { useField, useForm } from "vee-validate";
import { computed, onBeforeMount, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormState {
  contenidosAccionFormativa?: string | null;
  criteriosAcceso?: string | null;
  duracion?: string | null;
  programa?: string | null;
  lugarImparticion?: string | null;
  metodologia?: string | null;
  objetivos?: string | null;
  publicoObjetivo?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const module = getModule(ProyectosN2ListadoModule, store);
const authModule = getModule(AuthModule, store);
const comarcaId = authModule.user.comarcaId;
const route = useRoute();
const token = route.params.id as string;

const proyectoN2 = computed(() => module.proyectoN2?.planFormacion);
const editingPlanFormacion = ref<boolean>(false);

const schema = Yup.object({
  contenidosAccionFormativa: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.contenidosAccionFormativa")),
  criteriosAcceso: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.criteriosAcceso")),
  duracion: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.duracion")),
  programa: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.programa")),
  lugarImparticion: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.lugarImparticion")),
  metodologia: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.metodologia")),
  objetivos: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.objetivos")),
  publicoObjetivo: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.publicoObjetivo")),
  nPersonasAlcanzadas: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.formacion.campos.nPersonasAlcanzadas")),
});

const { resetForm, handleSubmit, meta } = useForm<Partial<FormState>>({
  validationSchema: schema,
});

const guardaDetalle = ref<boolean>(false);
const guardarPlanFormacion = handleSubmit(async (values) => {
  guardaDetalle.value = true;

  const update = diffObjects(meta.value.initialValues, values);
  if (Object.keys(update).length) {
    await module
      .patchFormacionById({
        id: token,
        comarcaId: comarcaId,
        planFormacion: {
          ...update,
        },
      })
      .then(() => {
        ElNotification({
          message: t("formularios.proyectosN2.guardar.mensaje.exito"),
          type: "success",
        });
        editingPlanFormacion.value = false;
        module.fetchById({ comarcaId: comarcaId, id: token as string });
      })
      .catch((err) => {
        if (typeof err === "object" && err?.error?.statusCode < 500) {
          showBackendError(t, err.error);
        } else {
          ElNotification({
            message: t("formularios.proyectosN2.cargar.error"),
            type: "error",
          });
        }
      })
      .finally(() => {
        guardaDetalle.value = false;
      });
  } else {
    ElNotification({
      message: t("formularios.proyectosN2.guardar.mensaje.exito"),
      type: "success",
    });
    editingPlanFormacion.value = false;
    module.fetchById({ comarcaId: comarcaId, id: token as string });
    guardaDetalle.value = false;
  }
});

onBeforeMount(() => {
  // load();
});

watch(editingPlanFormacion, () => {
  resetForm({
    values: {
      contenidosAccionFormativa: proyectoN2.value?.contenidosAccionFormativa,
      criteriosAcceso: proyectoN2.value?.criteriosAcceso,
      duracion: proyectoN2.value?.duracion,
      programa: proyectoN2.value?.programa,
      lugarImparticion: proyectoN2.value?.lugarImparticion,
      metodologia: proyectoN2.value?.metodologia,
      objetivos: proyectoN2.value?.objetivos,
      publicoObjetivo: proyectoN2.value?.publicoObjetivo,
    },
  });
});

const { value: contenidosAccionFormativa } = useField(
  "contenidosAccionFormativa"
);
const { value: criteriosAcceso } = useField("criteriosAcceso");
const { value: duracion } = useField("duracion");
const { value: programa } = useField("programa");
const { value: lugarImparticion } = useField("lugarImparticion");
const { value: metodologia } = useField("metodologia");
const { value: objetivos } = useField("objetivos");
const { value: publicoObjetivo } = useField("publicoObjetivo");

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.titulo")), 1)
      ]),
      (!editingPlanFormacion.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (editingPlanFormacion.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(guardarPlanFormacion),
              loading: guardaDetalle.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (editingPlanFormacion.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t(
                "formulario.proyecto.formacion.campos.contenidosAccionFormativa"
              )), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(proyectoN2)?.contenidosAccionFormativa ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "contenidosAccionFormativa",
                      placeholder: "",
                      modelValue: _unref(contenidosAccionFormativa),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(contenidosAccionFormativa) ? (contenidosAccionFormativa).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "contenidosAccionFormativa" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.programa")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(proyectoN2)?.programa ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "programa",
                      placeholder: "",
                      modelValue: _unref(programa),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(programa) ? (programa).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "programa" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.duracion")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(proyectoN2)?.duracion ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "duracion",
                      placeholder: "",
                      modelValue: _unref(duracion),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(duracion) ? (duracion).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_ErrorMessage, { name: "duracion" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.lugarImparticion")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(proyectoN2)?.lugarImparticion ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "lugarImparticion",
                      placeholder: "",
                      modelValue: _unref(lugarImparticion),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(lugarImparticion) ? (lugarImparticion).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_ErrorMessage, { name: "lugarImparticion" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.metodologia")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(proyectoN2)?.metodologia ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "metodologia",
                      placeholder: "",
                      modelValue: _unref(metodologia),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(metodologia) ? (metodologia).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_ErrorMessage, { name: "metodologia" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.objetivos")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(proyectoN2)?.objetivos ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "objetivos",
                      placeholder: "",
                      modelValue: _unref(objetivos),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(objetivos) ? (objetivos).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_ErrorMessage, { name: "objetivos" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.criteriosAcceso")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(proyectoN2)?.criteriosAcceso ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "criteriosAcceso",
                      placeholder: "",
                      modelValue: _unref(criteriosAcceso),
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(criteriosAcceso) ? (criteriosAcceso).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_ErrorMessage, { name: "criteriosAcceso" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nPlazas")), 1),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("label", _hoisted_75, _toDisplayString(_unref(proyectoN2)?.nPlazas ?? "-"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nSolicitudes")), 1),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("label", _hoisted_79, _toDisplayString(_unref(proyectoN2)?.nSolicitudes ?? "-"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.publicoObjetivo")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("label", _hoisted_83, _toDisplayString(_unref(proyectoN2)?.publicoObjetivo ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "publicoObjetivo",
                      placeholder: "",
                      modelValue: _unref(publicoObjetivo),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(publicoObjetivo) ? (publicoObjetivo).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createVNode(_component_ErrorMessage, { name: "publicoObjetivo" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nPersonasAlcanzadas")), 1),
          (!editingPlanFormacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                _createElementVNode("label", _hoisted_92, _toDisplayString(_unref(proyectoN2)?.nPersonasAlcanzadas ?? "-"), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h3", _hoisted_97, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.personasPorSexo.titulo")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_98, [
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nParticipantesMujer")), 1),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("label", _hoisted_103, _toDisplayString(_unref(proyectoN2)?.nParticipantesMujer ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nParticipantesVaron")), 1),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("label", _hoisted_107, _toDisplayString(_unref(proyectoN2)?.nParticipantesVaron ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nParticipantesOtro")), 1),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("label", _hoisted_111, _toDisplayString(_unref(proyectoN2)?.nParticipantesOtro ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.$t("formulario.proyecto.formacion.campos.nParticipantesNC")), 1),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("label", _hoisted_115, _toDisplayString(_unref(proyectoN2)?.nParticipantesNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})